import CryptoJS from "crypto-js";

const key = "KBglobal19850505KBglobal19850505";
const iv = "KBglobal19850505";

// 암호화
export default {
  encrypt(plainData) {
    // console.log("plainData :: " + JSON.stringify(plainData));

    let cipher = CryptoJS.AES.encrypt(JSON.stringify(plainData), CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    }).toString();


    return cipher;
  },

  // 복호화
  decrypt(cipher) {
    // console.log("cipher :: " + cipher);

    let plainData = CryptoJS.AES.decrypt(cipher, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);

    return JSON.parse(plainData);
  },

  getHash(time) {
    return CryptoJS.SHA256(time);
  },
};
